module.exports = __webpack_public_path__ + "assets/img/18_1826_big.ebb71412.jpg";